/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentExportTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Export Type API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, December 09, 2019 - 04:11:05 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      12/09/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const ExportTypes = {
    all: () => requests.get('/ExportTypes'),
    get: exporttypeid => requests.get(`/ExportType/${exporttypeid}`),
    create: exporttype => requests.post(`/ExportTypes`, exporttype),
    update: (exporttypeid, exporttype) => requests.put(`/ExportType/${exporttypeid}`, exporttype),
    delete: exporttypeid => requests.del(`/ExportType/${exporttypeid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentExportTypes.js